// src/hooks/useFetchGalleryImg.js
import { useState, useEffect } from 'react';
import axios from 'axios';
import { BASE_URL } from '../../routes/config';
// import { BASE_URL } from '../routes/config'; // adjust path as needed


const useFetchGalleryImg = (endpoint, options = {}) => {
  // const [data, setPageGallData] = useState([]);
  const [getPageGallData, setPageGallData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [getGalleryFolder, setGalleryFolder] = useState('');

  const fetchData = async () => {
    try {
      const res = await axios.post(`${BASE_URL}/${endpoint}`, {
        auth_key: "xxxxx", // or use options.auth_key
        ...options.body,
      });

      if (res.status === 200 && res.data.suc > 0) {
        setPageGallData(res.data.msg);
        setGalleryFolder(res?.data?.folder);
      } else {
        setPageGallData([]);
      }
    } catch (error) {
      console.error(`Error fetching from ${endpoint}:`, error);
      setPageGallData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [endpoint]);

  return { getPageGallData, getGalleryFolder, loading, refetch: fetchData };
};

export default useFetchGalleryImg;


